<!-- CapacityBidCard.vue -->
<template>
    <div>
      <Card>
        <template #title>
          <div class="flex align-items-center">
            <i class="pi pi-chart-line mr-2 text-primary"></i>
            Enchère de Capacité
          </div>
        </template>
        <template #content>
          <div class="capacity-card p-3 surface-100 border-round">
            <div class="flex align-items-center justify-content-between">
              <div class="flex align-items-center">
                <i class="pi pi-euro text-primary text-xl mr-2"></i>
                <span class="font-medium">Dernière enchère de capacité:</span>
              </div>
              <div class="flex align-items-center">
                <span class="text-xl font-bold mr-3">{{ capacityBid }} €/kW</span>
                <Button icon="pi pi-pencil" outlined size="small" @click="showCapacityBidDialog" />
              </div>
            </div>
          </div>
        </template>
      </Card>
      
      <!-- Edit Capacity Bid Dialog -->
      <Dialog v-model:visible="capacityBidDialog" header="Modifier l'enchère de capacité" :style="{ width: '450px' }" :modal="true">
        <div class="flex flex-column gap-3">
          <div class="field">
            <label for="capacity-bid" class="font-bold">Montant (€/kW)</label>
            <InputNumber id="capacity-bid" v-model="capacityBidValue" min="0" mode="decimal" :minFractionDigits="2" :maxFractionDigits="2" />
          </div>
        </div>
        <template #footer>
          <Button label="Annuler" icon="pi pi-times" outlined @click="closeCapacityBidDialog" />
          <Button label="Enregistrer" icon="pi pi-check" @click="saveCapacityBid" />
        </template>
      </Dialog>
    </div>
  </template>
  
  <script>
  export default {
    name: 'CapacityBidCard',
    props: {
      capacityBid: {
        type: Number,
        default: 0
      }
    },
    emits: ['update'],
    data() {
      return {
        capacityBidDialog: false,
        capacityBidValue: 0
      }
    },
    watch: {
      capacityBid: {
        immediate: true,
        handler(newValue) {
          this.capacityBidValue = newValue
        }
      }
    },
    methods: {
      showCapacityBidDialog() {
        this.capacityBidDialog = true
      },
      closeCapacityBidDialog() {
        this.capacityBidDialog = false
        // Reset value to original
        this.capacityBidValue = this.capacityBid
      },
      saveCapacityBid() {
        this.$emit('update', this.capacityBidValue)
        this.capacityBidDialog = false
      }
    }
  }
  </script>
  
  <style scoped>
  .capacity-card {
    background-color: var(--surface-card);
    border: 1px solid var(--surface-border);
    border-left: 4px solid var(--primary-color);
    transition: box-shadow 0.3s;
  }
  
  .capacity-card:hover {
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  }
  </style>